<template>
  <v-container
    fluid
    class="fill-height bg"
  >
    <v-row
      justify="center"
      align="center"
      class="fill-height ma-0 v-row__relative"
    >
      <v-btn
        fab
        absolute
        to="/app/processing-list"
        class="back-btn"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-card
        elevation="10"
      >
        <v-card-title class="title">Compartilhamento de projeto</v-card-title>
        <v-card-text>
          <v-container
            fluid
            class="fill-height"
          >
            <v-row
              class="fill-height ma-0"
            >
              <v-flex
                v-if="isLoading"
              >
                <v-progress-circular
                  indeterminate
                  color="info"
                  class="mr-2"
                >
                </v-progress-circular>
                <div class="subtitle-1">Carregando...</div>
              </v-flex>
              <v-flex
                v-else-if="isSuccess"
              >
                <v-alert
                  type="success"
                >
                  O compartilhamento foi iniciado com sucesso, iremos redireciona-lo em alguns segundos.
                </v-alert>
              </v-flex>
              <v-flex
                v-else
              >
                <v-alert
                  type="error"
                >
                  {{errorMessage}}
                </v-alert>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  import {projectShare} from "../../api/api-project"

  export default {
    name: "ProjectShare",
    data: () => ({
      isLoading: true,
      isSuccess: false,
      errorMessage: "Erro inesperado, por favor tente novamente mais tarde.",
    }),
    created() {
      const {token} = this.$route.params
      projectShare(this.$apiAuth.getAuthToken(), token)
        .then(() => {
          this.isSuccess = true
          setTimeout(() => {
            this.$router.push("/app/processing-list")
          }, 5000)
        })
        .catch((err) => {
          if (err.response)
            this.errorMessage = err.response.data.message
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  }
</script>

<style scoped lang="scss">
  .bg {
    background-image: url("../../assets/general/bg.jpg");
    background-size: cover;
  }

  .v-row__relative {
    position: relative;
  }

  .back-btn {
    top: 0;
    left: 0;
  }
</style>
